'use client';
"use strict";

var _excluded = ["onChange", "value", "defaultValue", "name", "isDisabled", "isFocusable", "isNative"],
  _excluded2 = ["colorScheme", "size", "variant", "children", "className", "isDisabled", "isFocusable"],
  _excluded3 = ["defaultChecked", "isChecked", "isFocusable", "isDisabled", "isReadOnly", "isRequired", "onChange", "isInvalid", "name", "value", "id", "data-radiogroup", "aria-describedby"],
  _excluded4 = ["spacing", "children", "isDisabled", "isFocusable", "inputProps"];
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
function _createForOfIteratorHelper(r, e) { var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (!t) { if (Array.isArray(r) || (t = _unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) { t && (r = t); var _n = 0, F = function F() {}; return { s: F, n: function n() { return _n >= r.length ? { done: !0 } : { done: !1, value: r[_n++] }; }, e: function e(r) { throw r; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var o, a = !0, u = !1; return { s: function s() { t = t.call(r); }, n: function n() { var r = t.next(); return a = r.done, r; }, e: function e(r) { u = !0, o = r; }, f: function f() { try { a || null == t["return"] || t["return"](); } finally { if (u) throw o; } } }; }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __export = function __export(target, all) {
  for (var name in all) __defProp(target, name, {
    get: all[name],
    enumerable: true
  });
};
var __copyProps = function __copyProps(to, from, except, desc) {
  if (from && _typeof(from) === "object" || typeof from === "function") {
    var _iterator = _createForOfIteratorHelper(__getOwnPropNames(from)),
      _step;
    try {
      var _loop = function _loop() {
        var key = _step.value;
        if (!__hasOwnProp.call(to, key) && key !== except) __defProp(to, key, {
          get: function get() {
            return from[key];
          },
          enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable
        });
      };
      for (_iterator.s(); !(_step = _iterator.n()).done;) {
        _loop();
      }
    } catch (err) {
      _iterator.e(err);
    } finally {
      _iterator.f();
    }
  }
  return to;
};
var __toCommonJS = function __toCommonJS(mod) {
  return __copyProps(__defProp({}, "__esModule", {
    value: true
  }), mod);
};

// src/index.ts
var src_exports = {};
__export(src_exports, {
  Radio: function Radio() {
    return _Radio;
  },
  RadioGroup: function RadioGroup() {
    return _RadioGroup;
  },
  useRadio: function useRadio() {
    return _useRadio;
  },
  useRadioGroup: function useRadioGroup() {
    return _useRadioGroup;
  },
  useRadioGroupContext: function useRadioGroupContext() {
    return _useRadioGroupContext;
  }
});
module.exports = __toCommonJS(src_exports);

// src/radio.tsx
var import_system2 = require("@chakra-ui/system");
var import_shared_utils4 = require("@chakra-ui/shared-utils");

// ../../utilities/object-utils/src/split.ts
function split(object, keys) {
  var picked = {};
  var omitted = {};
  for (var _i = 0, _Object$entries = Object.entries(object); _i < _Object$entries.length; _i++) {
    var _Object$entries$_i = _slicedToArray(_Object$entries[_i], 2),
      key = _Object$entries$_i[0],
      value = _Object$entries$_i[1];
    if (keys.includes(key)) picked[key] = value;else omitted[key] = value;
  }
  return [picked, omitted];
}

// src/radio-group.tsx
var import_system = require("@chakra-ui/system");
var import_shared_utils2 = require("@chakra-ui/shared-utils");
var import_react_context = require("@chakra-ui/react-context");

// src/use-radio-group.ts
var import_shared_utils = require("@chakra-ui/shared-utils");
var import_react_use_merge_refs = require("@chakra-ui/react-use-merge-refs");
var import_react = require("react");
function isInputEvent(value) {
  return value && (0, import_shared_utils.isObject)(value) && (0, import_shared_utils.isObject)(value.target);
}
function _useRadioGroup() {
  var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var onChangeProp = props.onChange,
    valueProp = props.value,
    defaultValue = props.defaultValue,
    nameProp = props.name,
    isDisabled = props.isDisabled,
    isFocusable = props.isFocusable,
    isNative = props.isNative,
    htmlProps = _objectWithoutProperties(props, _excluded);
  var _ref = (0, import_react.useState)(defaultValue || ""),
    _ref2 = _slicedToArray(_ref, 2),
    valueState = _ref2[0],
    setValue = _ref2[1];
  var isControlled = typeof valueProp !== "undefined";
  var value = isControlled ? valueProp : valueState;
  var ref = (0, import_react.useRef)(null);
  var focus = (0, import_react.useCallback)(function () {
    var rootNode = ref.current;
    if (!rootNode) return;
    var query = "input:not(:disabled):checked";
    var firstEnabledAndCheckedInput = rootNode.querySelector(query);
    if (firstEnabledAndCheckedInput) {
      firstEnabledAndCheckedInput.focus();
      return;
    }
    query = "input:not(:disabled)";
    var firstEnabledInput = rootNode.querySelector(query);
    firstEnabledInput == null ? void 0 : firstEnabledInput.focus();
  }, []);
  var uuid = (0, import_react.useId)();
  var fallbackName = "radio-".concat(uuid);
  var name = nameProp || fallbackName;
  var _onChange = (0, import_react.useCallback)(function (eventOrValue) {
    var nextValue = isInputEvent(eventOrValue) ? eventOrValue.target.value : eventOrValue;
    if (!isControlled) {
      setValue(nextValue);
    }
    onChangeProp == null ? void 0 : onChangeProp(String(nextValue));
  }, [onChangeProp, isControlled]);
  var getRootProps = (0, import_react.useCallback)(function () {
    var props2 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var forwardedRef = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
    return _objectSpread(_objectSpread({}, props2), {}, {
      ref: (0, import_react_use_merge_refs.mergeRefs)(forwardedRef, ref),
      role: "radiogroup"
    });
  }, []);
  var getRadioProps = (0, import_react.useCallback)(function () {
    var props2 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var ref2 = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
    var checkedKey = isNative ? "checked" : "isChecked";
    return _objectSpread(_objectSpread({}, props2), {}, _defineProperty(_defineProperty(_defineProperty({
      ref: ref2,
      name: name
    }, checkedKey, value != null ? props2.value === value : void 0), "onChange", function onChange(event) {
      _onChange(event);
    }), "data-radiogroup", true));
  }, [isNative, name, _onChange, value]);
  return {
    getRootProps: getRootProps,
    getRadioProps: getRadioProps,
    name: name,
    ref: ref,
    focus: focus,
    setValue: setValue,
    value: value,
    onChange: _onChange,
    isDisabled: isDisabled,
    isFocusable: isFocusable,
    htmlProps: htmlProps
  };
}

// src/radio-group.tsx
var import_react2 = require("react");
var import_jsx_runtime = require("react/jsx-runtime");
var _ref3 = (0, import_react_context.createContext)({
    name: "RadioGroupContext",
    strict: false
  }),
  _ref4 = _slicedToArray(_ref3, 2),
  RadioGroupProvider = _ref4[0],
  _useRadioGroupContext = _ref4[1];
var _RadioGroup = (0, import_system.forwardRef)(function (props, ref) {
  var colorScheme = props.colorScheme,
    size = props.size,
    variant = props.variant,
    children = props.children,
    className = props.className,
    isDisabled = props.isDisabled,
    isFocusable = props.isFocusable,
    rest = _objectWithoutProperties(props, _excluded2);
  var _useRadioGroup2 = _useRadioGroup(rest),
    value = _useRadioGroup2.value,
    onChange = _useRadioGroup2.onChange,
    getRootProps = _useRadioGroup2.getRootProps,
    name = _useRadioGroup2.name,
    htmlProps = _useRadioGroup2.htmlProps;
  var group = (0, import_react2.useMemo)(function () {
    return {
      name: name,
      size: size,
      onChange: onChange,
      colorScheme: colorScheme,
      value: value,
      variant: variant,
      isDisabled: isDisabled,
      isFocusable: isFocusable
    };
  }, [name, size, onChange, colorScheme, value, variant, isDisabled, isFocusable]);
  return /* @__PURE__ */(0, import_jsx_runtime.jsx)(RadioGroupProvider, {
    value: group,
    children: /* @__PURE__ */(0, import_jsx_runtime.jsx)(import_system.chakra.div, _objectSpread(_objectSpread({}, getRootProps(htmlProps, ref)), {}, {
      className: (0, import_shared_utils2.cx)("chakra-radio-group", className),
      children: children
    }))
  });
});
_RadioGroup.displayName = "RadioGroup";

// src/use-radio.ts
var import_form_control = require("@chakra-ui/form-control");
var import_shared_utils3 = require("@chakra-ui/shared-utils");

// ../visually-hidden/src/visually-hidden.style.ts
var visuallyHiddenStyle = {
  border: "0",
  clip: "rect(0, 0, 0, 0)",
  height: "1px",
  width: "1px",
  margin: "-1px",
  padding: "0",
  overflow: "hidden",
  whiteSpace: "nowrap",
  position: "absolute"
};

// src/use-radio.ts
var import_focus_visible = require("@zag-js/focus-visible");
var import_react3 = require("react");
function _useRadio() {
  var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var defaultChecked = props.defaultChecked,
    isCheckedProp = props.isChecked,
    isFocusable = props.isFocusable,
    isDisabledProp = props.isDisabled,
    isReadOnlyProp = props.isReadOnly,
    isRequiredProp = props.isRequired,
    onChange = props.onChange,
    isInvalidProp = props.isInvalid,
    name = props.name,
    value = props.value,
    idProp = props.id,
    dataRadioGroup = props["data-radiogroup"],
    ariaDescribedBy = props["aria-describedby"],
    htmlProps = _objectWithoutProperties(props, _excluded3);
  var uuid = "radio-".concat((0, import_react3.useId)());
  var formControl = (0, import_form_control.useFormControlContext)();
  var group = _useRadioGroupContext();
  var isWithinRadioGroup = !!group || !!dataRadioGroup;
  var isWithinFormControl = !!formControl;
  var id = isWithinFormControl && !isWithinRadioGroup ? formControl.id : uuid;
  id = idProp != null ? idProp : id;
  var isDisabled = isDisabledProp != null ? isDisabledProp : formControl == null ? void 0 : formControl.isDisabled;
  var isReadOnly = isReadOnlyProp != null ? isReadOnlyProp : formControl == null ? void 0 : formControl.isReadOnly;
  var isRequired = isRequiredProp != null ? isRequiredProp : formControl == null ? void 0 : formControl.isRequired;
  var isInvalid = isInvalidProp != null ? isInvalidProp : formControl == null ? void 0 : formControl.isInvalid;
  var _ref5 = (0, import_react3.useState)(false),
    _ref6 = _slicedToArray(_ref5, 2),
    isFocusVisible = _ref6[0],
    setIsFocusVisible = _ref6[1];
  var _ref7 = (0, import_react3.useState)(false),
    _ref8 = _slicedToArray(_ref7, 2),
    isFocused = _ref8[0],
    setFocused = _ref8[1];
  var _ref9 = (0, import_react3.useState)(false),
    _ref10 = _slicedToArray(_ref9, 2),
    isHovered = _ref10[0],
    setHovering = _ref10[1];
  var _ref11 = (0, import_react3.useState)(false),
    _ref12 = _slicedToArray(_ref11, 2),
    isActive = _ref12[0],
    setActive = _ref12[1];
  var _ref13 = (0, import_react3.useState)(Boolean(defaultChecked)),
    _ref14 = _slicedToArray(_ref13, 2),
    isCheckedState = _ref14[0],
    setChecked = _ref14[1];
  var isControlled = typeof isCheckedProp !== "undefined";
  var isChecked = isControlled ? isCheckedProp : isCheckedState;
  (0, import_react3.useEffect)(function () {
    return (0, import_focus_visible.trackFocusVisible)(setIsFocusVisible);
  }, []);
  var handleChange = (0, import_react3.useCallback)(function (event) {
    if (isReadOnly || isDisabled) {
      event.preventDefault();
      return;
    }
    if (!isControlled) {
      setChecked(event.target.checked);
    }
    onChange == null ? void 0 : onChange(event);
  }, [isControlled, isDisabled, isReadOnly, onChange]);
  var onKeyDown = (0, import_react3.useCallback)(function (event) {
    if (event.key === " ") {
      setActive(true);
    }
  }, [setActive]);
  var onKeyUp = (0, import_react3.useCallback)(function (event) {
    if (event.key === " ") {
      setActive(false);
    }
  }, [setActive]);
  var getRadioProps = (0, import_react3.useCallback)(function () {
    var props2 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var ref = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
    return _objectSpread(_objectSpread({}, props2), {}, {
      ref: ref,
      "data-active": (0, import_shared_utils3.dataAttr)(isActive),
      "data-hover": (0, import_shared_utils3.dataAttr)(isHovered),
      "data-disabled": (0, import_shared_utils3.dataAttr)(isDisabled),
      "data-invalid": (0, import_shared_utils3.dataAttr)(isInvalid),
      "data-checked": (0, import_shared_utils3.dataAttr)(isChecked),
      "data-focus": (0, import_shared_utils3.dataAttr)(isFocused),
      "data-focus-visible": (0, import_shared_utils3.dataAttr)(isFocused && isFocusVisible),
      "data-readonly": (0, import_shared_utils3.dataAttr)(isReadOnly),
      "aria-hidden": true,
      onMouseDown: (0, import_shared_utils3.callAllHandlers)(props2.onMouseDown, function () {
        return setActive(true);
      }),
      onMouseUp: (0, import_shared_utils3.callAllHandlers)(props2.onMouseUp, function () {
        return setActive(false);
      }),
      onMouseEnter: (0, import_shared_utils3.callAllHandlers)(props2.onMouseEnter, function () {
        return setHovering(true);
      }),
      onMouseLeave: (0, import_shared_utils3.callAllHandlers)(props2.onMouseLeave, function () {
        return setHovering(false);
      })
    });
  }, [isActive, isHovered, isDisabled, isInvalid, isChecked, isFocused, isReadOnly, isFocusVisible]);
  var _ref15 = formControl != null ? formControl : {},
    onFocus = _ref15.onFocus,
    onBlur = _ref15.onBlur;
  var getInputProps = (0, import_react3.useCallback)(function () {
    var props2 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var ref = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
    var trulyDisabled = isDisabled && !isFocusable;
    return _objectSpread(_objectSpread({}, props2), {}, {
      id: id,
      ref: ref,
      type: "radio",
      name: name,
      value: value,
      onChange: (0, import_shared_utils3.callAllHandlers)(props2.onChange, handleChange),
      onBlur: (0, import_shared_utils3.callAllHandlers)(onBlur, props2.onBlur, function () {
        return setFocused(false);
      }),
      onFocus: (0, import_shared_utils3.callAllHandlers)(onFocus, props2.onFocus, function () {
        return setFocused(true);
      }),
      onKeyDown: (0, import_shared_utils3.callAllHandlers)(props2.onKeyDown, onKeyDown),
      onKeyUp: (0, import_shared_utils3.callAllHandlers)(props2.onKeyUp, onKeyUp),
      checked: isChecked,
      disabled: trulyDisabled,
      readOnly: isReadOnly,
      required: isRequired,
      "aria-invalid": (0, import_shared_utils3.ariaAttr)(isInvalid),
      "aria-disabled": (0, import_shared_utils3.ariaAttr)(trulyDisabled),
      "aria-required": (0, import_shared_utils3.ariaAttr)(isRequired),
      "data-readonly": (0, import_shared_utils3.dataAttr)(isReadOnly),
      "aria-describedby": ariaDescribedBy,
      style: visuallyHiddenStyle
    });
  }, [isDisabled, isFocusable, id, name, value, handleChange, onBlur, onFocus, onKeyDown, onKeyUp, isChecked, isReadOnly, isRequired, isInvalid, ariaDescribedBy]);
  var getLabelProps = function getLabelProps() {
    var props2 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var ref = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
    return _objectSpread(_objectSpread({}, props2), {}, {
      ref: ref,
      onMouseDown: (0, import_shared_utils3.callAllHandlers)(props2.onMouseDown, stopEvent),
      "data-disabled": (0, import_shared_utils3.dataAttr)(isDisabled),
      "data-checked": (0, import_shared_utils3.dataAttr)(isChecked),
      "data-invalid": (0, import_shared_utils3.dataAttr)(isInvalid)
    });
  };
  var getRootProps = function getRootProps(props2) {
    var ref = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
    return _objectSpread(_objectSpread({}, props2), {}, {
      ref: ref,
      "data-disabled": (0, import_shared_utils3.dataAttr)(isDisabled),
      "data-checked": (0, import_shared_utils3.dataAttr)(isChecked),
      "data-invalid": (0, import_shared_utils3.dataAttr)(isInvalid)
    });
  };
  var state = {
    isInvalid: isInvalid,
    isFocused: isFocused,
    isChecked: isChecked,
    isActive: isActive,
    isHovered: isHovered,
    isDisabled: isDisabled,
    isReadOnly: isReadOnly,
    isRequired: isRequired
  };
  return {
    state: state,
    /**
     * @deprecated - use `getRadioProps` instead
     */
    getCheckboxProps: getRadioProps,
    getRadioProps: getRadioProps,
    getInputProps: getInputProps,
    getLabelProps: getLabelProps,
    getRootProps: getRootProps,
    htmlProps: htmlProps
  };
}
function stopEvent(event) {
  event.preventDefault();
  event.stopPropagation();
}

// src/radio.tsx
var import_jsx_runtime2 = require("react/jsx-runtime");
var _Radio = (0, import_system2.forwardRef)(function (props, ref) {
  var _a;
  var group = _useRadioGroupContext();
  var onChangeProp = props.onChange,
    valueProp = props.value;
  var styles = (0, import_system2.useMultiStyleConfig)("Radio", _objectSpread(_objectSpread({}, group), props));
  var ownProps = (0, import_system2.omitThemingProps)(props);
  var _ownProps$spacing = ownProps.spacing,
    spacing = _ownProps$spacing === void 0 ? "0.5rem" : _ownProps$spacing,
    children = ownProps.children,
    _ownProps$isDisabled = ownProps.isDisabled,
    isDisabled = _ownProps$isDisabled === void 0 ? group == null ? void 0 : group.isDisabled : _ownProps$isDisabled,
    _ownProps$isFocusable = ownProps.isFocusable,
    isFocusable = _ownProps$isFocusable === void 0 ? group == null ? void 0 : group.isFocusable : _ownProps$isFocusable,
    htmlInputProps = ownProps.inputProps,
    rest = _objectWithoutProperties(ownProps, _excluded4);
  var isChecked = props.isChecked;
  if ((group == null ? void 0 : group.value) != null && valueProp != null) {
    isChecked = group.value === valueProp;
  }
  var onChange = onChangeProp;
  if ((group == null ? void 0 : group.onChange) && valueProp != null) {
    onChange = (0, import_shared_utils4.callAll)(group.onChange, onChangeProp);
  }
  var name = (_a = props == null ? void 0 : props.name) != null ? _a : group == null ? void 0 : group.name;
  var _useRadio2 = _useRadio(_objectSpread(_objectSpread({}, rest), {}, {
      isChecked: isChecked,
      isFocusable: isFocusable,
      isDisabled: isDisabled,
      onChange: onChange,
      name: name
    })),
    getInputProps = _useRadio2.getInputProps,
    getCheckboxProps = _useRadio2.getCheckboxProps,
    getLabelProps = _useRadio2.getLabelProps,
    getRootProps = _useRadio2.getRootProps,
    htmlProps = _useRadio2.htmlProps;
  var _split = split(htmlProps, import_system2.layoutPropNames),
    _split2 = _slicedToArray(_split, 2),
    layoutProps = _split2[0],
    otherProps = _split2[1];
  var checkboxProps = getCheckboxProps(otherProps);
  var inputProps = getInputProps(htmlInputProps, ref);
  var labelProps = getLabelProps();
  var rootProps = Object.assign({}, layoutProps, getRootProps());
  var rootStyles = _objectSpread({
    display: "inline-flex",
    alignItems: "center",
    verticalAlign: "top",
    cursor: "pointer",
    position: "relative"
  }, styles.container);
  var checkboxStyles = _objectSpread({
    display: "inline-flex",
    alignItems: "center",
    justifyContent: "center",
    flexShrink: 0
  }, styles.control);
  var labelStyles = _objectSpread({
    userSelect: "none",
    marginStart: spacing
  }, styles.label);
  return /* @__PURE__ */(0, import_jsx_runtime2.jsxs)(import_system2.chakra.label, _objectSpread(_objectSpread({
    className: "chakra-radio"
  }, rootProps), {}, {
    __css: rootStyles,
    children: [/* @__PURE__ */(0, import_jsx_runtime2.jsx)("input", _objectSpread({
      className: "chakra-radio__input"
    }, inputProps)), /* @__PURE__ */(0, import_jsx_runtime2.jsx)(import_system2.chakra.span, _objectSpread(_objectSpread({
      className: "chakra-radio__control"
    }, checkboxProps), {}, {
      __css: checkboxStyles
    })), children && /* @__PURE__ */(0, import_jsx_runtime2.jsx)(import_system2.chakra.span, _objectSpread(_objectSpread({
      className: "chakra-radio__label"
    }, labelProps), {}, {
      __css: labelStyles,
      children: children
    }))]
  }));
});
_Radio.displayName = "Radio";
// Annotate the CommonJS export names for ESM import in node:
0 && (module.exports = {
  Radio: _Radio,
  RadioGroup: _RadioGroup,
  useRadio: _useRadio,
  useRadioGroup: _useRadioGroup,
  useRadioGroupContext: _useRadioGroupContext
});